import React from 'react';
import PropTypes from 'prop-types';
import './AppliedFiltersBar.css';

const AppliedFiltersBar = ({
  items = [],
  onClear,
  label = 'Applied filters:',
  clearButtonLabel = 'Remove filter',
  separator = ' | ',
  className = '',
  clearButtonDisabled = false,
}) => {
  const labels = items.filter((item) => item != null && String(item).trim() !== '');
  if (!labels.length) return null;

  return (
    <div className={`applied-filters-bar ${className}`.trim()}>
      <span className="applied-filters-bar__label">{label}</span>
      <span className="applied-filters-bar__list">{labels.join(separator)}</span>
      {onClear && (
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary applied-filters-bar__clear"
          onClick={onClear}
          disabled={clearButtonDisabled}
        >
          {clearButtonLabel}
        </button>
      )}
    </div>
  );
};

AppliedFiltersBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  onClear: PropTypes.func,
  label: PropTypes.string,
  clearButtonLabel: PropTypes.string,
  separator: PropTypes.string,
  className: PropTypes.string,
  clearButtonDisabled: PropTypes.bool,
};

export default AppliedFiltersBar;
